
function PlayerLabel({playerName, playerColor}) {
  return (
    <div className="player-label">
      <div className="player-name">{playerName}</div>
      <svg viewBox="0 0 73.07 33.98" preserveAspectRatio="none" className="label-background">
        <defs>
          <path id="player-indicator-path" d="M63.24 1.16c-.08-.03-1.63-.13-2.84-.12-1.71.02-3.38.04-4.85.1H29.89c-.26-.06-.51-.11-.73-.15-.03.03.02.09.06.15h-3.25s.02 0 .02-.01c-1.03 0-1.86.04-2.61-.08-.5.03-.71.07-.79.1h-1.56c.08-.16.63-.37.05-.54C23.18.4 10.92.14 10.8.25 8.81.35 9.03.14 8.62.01 7.15.13 7.31.43 6.41.65 5.65.59 5.05.55 4.55.52l-.7-.03c-.26 0-.54-.02-.8-.01-.52.02-1.02.19-1.49.55-.46.36-.91.94-1.03 1.82.1-.06.2-.1.31-.15-.03.14-.04.28-.05.41-.01.23-.02.43-.03.61v.45c.01.28.04.53.07.78.06.51.11 1.06.03 1.99C.8 7.05.4 7.3.52 9.01L.19 7.66C.2 9.02.3 11.02.02 10.31c.34 2.38.21 6.54.4 9.51l-.26-.2c.16.77.15 2.18.16 3.56v1.61c0 .24.01.47.06.68.15.87.69 1.44 1.09 1.66.06.09.12.19.19.27.64.38 1.39.4 2.1.32l1.54-.17c1.38.03.91.42 1.03.31 3.04-.07 5.42-.09 7.37.04.49-.34 3.68-.44 6.22-.48 12.24.21 25.38-.11 36.76-.51.51 0 1.09-.04 1.7-.1h4.48c5.58 0 10.22 7.17 10.22 7.17V8.18s-1.95-6.8-9.84-7.02Z" />
          <clipPath id="player-indicator-clip-path">
            <use href="#player-indicator-path"/>
          </clipPath>
        </defs>
        <g >
          <use clipPath="url(#player-indicator-clip-path)" href="#player-indicator-path" style={{fill: playerName ? playerColor : '#333333', strokeWidth: 2, stroke: '#ffffff', strokeOpacity: playerColor ? .2 : .1}} data-name="Layer 1"/>
        </g>
      </svg>
    </div>
  );
}

export default PlayerLabel
